import { useEffect, useState } from 'react';
import './Testimonial.css';

function Testimonial() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Aarti Jain",
      text: "Absolutely loving the new UI! The recharge process is smooth, quick, and hassle-free....Everything works flawlessly,great app!✅✅",
      rating: 5
    },
    {
      id: 2,
      name: "Ranjana  Ambadkar",
      text: "One of the best app for recharges and bill payments quick recahrges with cashback and also like the coins rewards",
      rating: 5
    },
    {
      id: 3,
      name: "Rameshwari Hedau",
      text: "Amazing recharge app! Super fast, no hidden charges, and the cashback rewards are a bonus. Smooth UI and reliable every single time. Highly recommended!",
      rating: 5
    },
    {
      id: 4,
      name: "Atharva Meshram",
      text: "The app works smoothly and payments are quick. No bugs or crashes. Very helpful and easy to use. UI is simple and user-friendly. Transactions are fast and reliable. Great experience overall.",
      rating: 5
    },
    {
      id: 5,
      name: "Sharwari G",
      text: "Easy to navigate , easily I could recharge back , your experience is nice and has easy and simple payments , user friendly app .",
      rating: 5
    },
    {
      id: 6,
      name: "Prajapati Khetaram",
      text: "customer support is very Good and fast ..",
      rating: 5
    },
    {
      id: 7,
      name: "Asit Dhanvijay",
      text: "Really nice app with an easy to navigate through interface. Makes bill payments very simple and fast.",
      rating: 5
    },
    {
      id: 8,
      name: "Manthan Kurve",
      text: "Great app! It makes mobile recharging incredibly fast and hassle-free.",
      rating: 5
    },
    {
      id: 9,
      name: "Shubham Agrawal",
      text: "Best & Simple App for Recharge, which gives you excellent cashbacks",
      rating: 5
    },
    {
      id: 10,
      name: "abhishek meharkure",
      text: "Great app! Smooth interface and quick recharge process.",
      rating: 5
    }
  ];

  // Auto-slide effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const getCardPosition = (index) => {
    const diff = index - currentIndex;
    if (diff === 0) return 'center';
    if (diff === 1 || diff === -(testimonials.length - 1)) return 'right';
    if (diff === -1 || diff === testimonials.length - 1) return 'left';
    return 'hidden';
  };

  return (
    <section id="testimonial" className="testimonial-section">
      <div className="testimonial-wrapper-full">
        <h2 className="testimonial-title">
          What Our Users Say
        </h2>
        
        <div className="testimonial-carousel">
          <div className="carousel-track">
            {testimonials.map((testimonial, index) => (
              <div 
                key={testimonial.id} 
                className={`testimonial-card-carousel ${getCardPosition(index)}`}
              >
                <div className="testimonial-rating">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <span key={i} className="star">★</span>
                  ))}
                </div>
                
                <p className="testimonial-text">
                  "{testimonial.text}"
                </p>
                
                <div className="testimonial-author">
                  <div className="author-avatar">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div className="author-info">
                    <h4 className="author-name">{testimonial.name}</h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="carousel-indicators">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`indicator ${currentIndex === index ? 'active' : ''}`}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonial;
